import React, {useState} from "react";
import {Badge, Button, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {Edit2} from "react-feather";
import {AvField, AvForm, AvInput} from "availity-reactstrap-validation";
import Select from "react-select";
import API from "../../../utils/API";

const humanizeDuration = require("humanize-duration");

const TOGGLE_FIELD_TYPES = ['toggle', 'toggleoptions', 'toggleoptionsmulti', 'togglestring', 'toggleflag'];

const Scrubber = ({publisherRcId,data}) => {

    const [edit,setEdit] = useState(false)
    const [config, setConfig] = useState(() => {
        const c = data.config || {};
        const fields = data.fields || [];
        const result = { ...c };
        fields.forEach(f => {
            if (TOGGLE_FIELD_TYPES.includes(f.type)) {
                if (f.isOn !== true) {
                    delete result[f.name];
                } else if (result[f.name] == null || result[f.name] === '' || (Array.isArray(result[f.name]) && result[f.name].length === 0)) {
                    if (f.type === 'toggleoptionsmulti' && Array.isArray(f.defaultValue)) {
                        result[f.name] = f.defaultValue;
                    } else if ((f.type === 'toggleoptions' || f.type === 'togglestring') && f.defaultValue != null) {
                        result[f.name] = f.defaultValue;
                    } else if (f.type === 'toggleflag' && f.defaultValue != null) {
                        result[f.name] = f.defaultValue;
                    }
                }
            }
        });
        return result;
    })
    const [enabled, setEnabled] = useState(data.enabled)
    const [toggleOnState, setToggleOnState] = useState(() => {
        const s = {};
        (data.fields || []).forEach(f => {
            if (TOGGLE_FIELD_TYPES.includes(f.type)) {
                s[f.name] = f.isOn === true;
            }
        });
        return s;
    })

    const handleChange = (e) => {
        setConfig({ ...config, [e.target.name]: e.target.value })
    };

    const removeConfigKey = (key) => {
        const { [key]: _, ...rest } = config;
        setConfig(rest);
    };

    const submit = () => {
        API.put('/admin/scrubber/rcid/'+publisherRcId,{name:data.name,enabled,config:config}).then((response) => {
            setEdit(false)
        });
    }

    return (
        <div className="col-sm-12 col-md-6">
            <div className="border shadow p-2 m-2">
                <div className="row">
                    <div className="col">
                        <h5>{data.name}</h5>
                    </div>
                    <div className="col-auto">
                        <Edit2 onClick={() => setEdit(true)} className="align-middle mr-1 cursor-pointer" size={18}/>
                    </div>
                </div>
                <>
                    {enabled ?
                        <Badge color="success" className="mr-1 mb-1 badge-pill">Enabled</Badge>
                        :
                        <Badge color="secondary" className="mr-1 mb-1 badge-pill">Disabled</Badge>
                    }
                    {enabled && config &&
                        (() => {
                            return (
                        <ul className="list-unstyled mb-0">
                            {(data.fields || []).map((field) => {
                                const key = field.name;
                                if (!(key in config)) return null;
                                const val = config[key];
                                const type = field.type;
                                if (type === 'toggle') {
                                    return (<li className="mb-1" key={key}>{key}: <strong>{val ? 'On' : 'Off'}</strong></li>);
                                }
                                if (type === 'toggleoptions' || type === 'togglestring') {
                                    const isOff = val === false || val === undefined || val === '';
                                    const displayVal = !isOff ? val : 'Off';
                                    const leadAgeReadable = key === 'Lead age, maximum' && !isOff && (
                                        <span className="text-black-50"> ({humanizeDuration(val * 1000)})</span>
                                    );
                                    return (<li className="mb-1" key={key}>{key}: <strong>{displayVal}{leadAgeReadable}</strong></li>);
                                }
                                if (type === 'toggleoptionsmulti') {
                                    const on = Array.isArray(val) && val.length > 0;
                                    return (<li className="mb-1" key={key}>{key}: <strong>{on ? val.join(', ') : 'Off'}</strong></li>);
                                }
                                if (type === 'toggleflag') {
                                    return (<li className="mb-1" key={key}>{key}: <strong>{Number(val) === 2 && <span className="badge badge-warning">Fail on yellow</span>}{Number(val) === 3 && <span className="badge badge-danger">Fail on red</span>}{val && Number(val) !== 2 && Number(val) !== 3 && val}</strong></li>);
                                }
                                if (key.indexOf('flag value') >= 0) {
                                    return (<li className="mb-1" key={key}>{key}: <strong>{Number(config[key]) === 2 && <span className="badge badge-warning">Fail on yellow</span>}{Number(config[key]) === 3 && <span className="badge badge-danger">Fail on red</span>}</strong></li>);
                                }
                                if (key === 'Lead age, maximum') {
                                    return (<li className="mb-1" key={key}>{key}: <strong>{config[key]} {config[key] && <span className="text-black-50">({humanizeDuration(config[key]*1000)})</span>}</strong></li>);
                                }
                                return (<li className="mb-1" key={key}>{key}: <strong>{Array.isArray(config[key]) ? config[key].join(", ") : config[key]}</strong></li>);
                            })}
                        </ul>
                            );
                        })()}
                </>
                <Modal isOpen={edit} toggle={() => setEdit(false)} size="lg">
                    <ModalHeader toggle={() => setEdit(false)}>Edit {data.name}</ModalHeader>
                    <ModalBody>
                    <AvForm id={`scrubber-edit-form-${data.name}`} onValidSubmit={submit}>
                        <FormGroup className="d-flex justify-content-start">
                            <div className="d-flex align-items-center">
                                <div className="custom-control custom-switch mr-2">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id={`scrubber-enabled-toggle-${data.name}`}
                                        checked={!!enabled}
                                        onChange={(e) => setEnabled(e.target.checked)}
                                    />
                                    <label className="custom-control-label" htmlFor={`scrubber-enabled-toggle-${data.name}`} />
                                </div>
                                <Label className="mb-0 mr-2">Enabled</Label>
                                <span className="text-muted small">{enabled ? 'On' : 'Off'}</span>
                            </div>
                        </FormGroup>
                        {enabled && (
                        <>
                        {
                            data.fields.map((field, index) => {
                                if (field.type==='string') {
                                    return (
                                        <React.Fragment key={index}>
                                        <FormGroup>
                                            <Label>{field.name} {field.name === 'Lead age, maximum' && <span className="text-black-50">(in seconds, 3600=1 hour) {config[field.name] && <div>{humanizeDuration(config[field.name]*1000)}</div>}</span>}</Label>
                                            <AvInput onChange={handleChange} type="text" name={field.name} value={config[field.name]} placeholder={"Enter "+field.name} />
                                        </FormGroup>
                                        </React.Fragment>
                                    )
                                }else if (field.type==='options') {
                                    return (
                                        <React.Fragment key={index}>
                                        <FormGroup>
                                            <Label>{field.name}</Label>
                                            <AvField
                                                type="select"
                                                name={field.name}
                                                value={config[field.name]}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Select...</option>
                                                {
                                                    field.options.map((option, index) => (
                                                        <option key={index} value={option}>{option}</option>
                                                    ))
                                                }
                                            </AvField>
                                        </FormGroup>
                                        </React.Fragment>
                                    )
                                }else if (field.type==='flagoptions') {
                                    return (
                                        <React.Fragment key={index}>
                                        <FormGroup>
                                            <Label>{field.name}</Label>
                                            <AvField
                                                type="select"
                                                name={field.name}
                                                value={config[field.name]}
                                                onChange={handleChange}
                                                required
                                                className={parseInt(config[field.name])===3?`bg-danger text-white`:(parseInt(config[field.name])===2?`bg-warning text-white`:``)}
                                            >
                                                <option value="">Select...</option>
                                                {
                                                    field.options.map((option, index) => (
                                                        <option key={index} value={option}>
                                                            {Number(option) === 2 && <span className="text-warning">Fail on yellow</span>}
                                                            {Number(option) === 3 && <>Fail on red</>}
                                                        </option>
                                                    ))
                                                }
                                            </AvField>
                                        </FormGroup>
                                        </React.Fragment>
                                    )
                                }else if (field.type==='multioptions') {
                                    let optionsPrepared = []
                                    for (let i in field.options) {
                                        optionsPrepared.push({
                                            label:field.options[i],
                                            value:field.options[i]
                                        })
                                    }
                                    let valuePrepared = []
                                    const multiVal = config[field.name]
                                    if (Array.isArray(multiVal)) {
                                        for (let i in multiVal) {
                                            valuePrepared.push({
                                                label:multiVal[i],
                                                value:multiVal[i]
                                            })
                                        }
                                    }
                                    return (
                                        <React.Fragment key={index}>
                                        <FormGroup>
                                            <Label>{field.name}</Label>
                                            <Select
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                options={optionsPrepared}
                                                value={valuePrepared}
                                                onChange={(value)=>{
                                                    let valueSavePrepared = []
                                                    for (let i in value) {
                                                        valueSavePrepared.push(value[i].value)
                                                    }
                                                    setConfig({ ...config, [field.name]: valueSavePrepared })
                                                }}
                                                isMulti
                                                placeholder={field.name}
                                            />
                                        </FormGroup>
                                        </React.Fragment>
                                    )
                                }else if (field.type==='toggle') {
                                    const isOn = toggleOnState[field.name] !== undefined ? toggleOnState[field.name] : (field.isOn === true);
                                    return (
                                        <React.Fragment key={index}>
                                        <FormGroup>
                                            <div className="d-flex align-items-center">
                                                <div className="custom-control custom-switch mr-2">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id={`switch-${field.name}-${index}`}
                                                        checked={!!isOn}
                                                        onChange={(e)=>{
                                                            const on = e.target.checked;
                                                            setToggleOnState(prev => ({ ...prev, [field.name]: on }));
                                                            if (on) {
                                                                setConfig({ ...config, [field.name]: true });
                                                            } else {
                                                                removeConfigKey(field.name);
                                                            }
                                                        }}
                                                    />
                                                    <label className="custom-control-label" htmlFor={`switch-${field.name}-${index}`} />
                                                </div>
                                                <Label className="mb-0 mr-2">{field.name}</Label>
                                                <span className="text-muted small">{isOn ? 'On' : 'Off'}</span>
                                            </div>
                                        </FormGroup>
                                        </React.Fragment>
                                    )
                                }else if (field.type==='toggleflag') {
                                    const isOn = toggleOnState[field.name] !== undefined ? toggleOnState[field.name] : (field.isOn === true);
                                    const optionsPrepared = (field.options || []).map(opt => {
                                        const n = Number(opt);
                                        const label = n === 2 ? 'Fail on yellow' : n === 3 ? 'Fail on red' : String(opt);
                                        return { label, value: opt };
                                    });
                                    const val = config[field.name];
                                    const valuePrepared = (val != null && val !== '') ? (optionsPrepared.find(o => String(o.value) === String(val)) || { label: String(val), value: val }) : null;
                                    const flagSelectClass = (val != null && val !== '') ? (parseInt(val) === 3 ? 'scrubber-select-danger' : parseInt(val) === 2 ? 'scrubber-select-warning' : 'scrubber-select-has-value') : '';
                                    return (
                                        <React.Fragment key={index}>
                                        <FormGroup>
                                            <div className="d-flex align-items-center flex-wrap">
                                                <div className="custom-control custom-switch mr-2">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id={`switch-flag-${field.name}-${index}`}
                                                        checked={!!isOn}
                                                        onChange={(e)=>{
                                                            const on = e.target.checked;
                                                            setToggleOnState(prev => ({ ...prev, [field.name]: on }));
                                                            if (on) {
                                                                const initial = field.defaultValue != null ? field.defaultValue : (config[field.name] || '');
                                                                setConfig({ ...config, [field.name]: initial });
                                                            } else {
                                                                removeConfigKey(field.name);
                                                            }
                                                        }}
                                                    />
                                                    <label className="custom-control-label" htmlFor={`switch-flag-${field.name}-${index}`} />
                                                </div>
                                                <Label className="mb-0 mr-2">{field.name}</Label>
                                                {isOn && (
                                                    <>
                                                        <AvInput type="hidden" name={field.name} value={config[field.name] || ''} required />
                                                        <div className={`flex-grow-1 ml-1 react-select-container ${flagSelectClass}`.trim()} style={{ minWidth: 180 }}>
                                                            <Select
                                                                classNamePrefix="react-select"
                                                                options={optionsPrepared}
                                                                value={valuePrepared}
                                                                onChange={(option)=>{
                                                                    const v = option ? option.value : '';
                                                                    setConfig({ ...config, [field.name]: v });
                                                                }}
                                                                placeholder="Select..."
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </FormGroup>
                                        </React.Fragment>
                                    )
                                }else if (field.type==='toggleoptions') {
                                    const isOn = toggleOnState[field.name] !== undefined ? toggleOnState[field.name] : (field.isOn === true);
                                    const singleVal = config[field.name];
                                    const optionsPrepared = (field.options || []).map(opt => ({ label: opt, value: opt }));
                                    const valuePrepared = (singleVal != null && singleVal !== '') ? { label: singleVal, value: singleVal } : null;
                                    return (
                                        <React.Fragment key={index}>
                                        <FormGroup>
                                            <div className="d-flex align-items-center flex-wrap">
                                                <div className="custom-control custom-switch mr-2">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id={`switch-opt-${field.name}-${index}`}
                                                        checked={!!isOn}
                                                        onChange={(e)=>{
                                                            const on = e.target.checked;
                                                            setToggleOnState(prev => ({ ...prev, [field.name]: on }));
                                                            if (on) {
                                                                const initial = field.defaultValue != null ? field.defaultValue : (config[field.name] || '');
                                                                setConfig({ ...config, [field.name]: initial });
                                                            } else {
                                                                removeConfigKey(field.name);
                                                            }
                                                        }}
                                                    />
                                                    <label className="custom-control-label" htmlFor={`switch-opt-${field.name}-${index}`} />
                                                </div>
                                                <Label className="mb-0 mr-2">{field.name}</Label>
                                                {isOn && (
                                                    <>
                                                        <AvInput type="hidden" name={field.name} value={config[field.name] || ''} required />
                                                        <div className="flex-grow-1 ml-1" style={{ minWidth: 180 }}>
                                                            <Select
                                                                className="react-select-container"
                                                                classNamePrefix="react-select"
                                                                options={optionsPrepared}
                                                                value={valuePrepared}
                                                                onChange={(option)=>{
                                                                    const v = option ? option.value : '';
                                                                    setConfig({ ...config, [field.name]: v });
                                                                }}
                                                                placeholder={`Select ${field.name}...`}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </FormGroup>
                                        </React.Fragment>
                                    )
                                }else if (field.type==='toggleoptionsmulti') {
                                    const isOn = toggleOnState[field.name] !== undefined ? toggleOnState[field.name] : (field.isOn === true);
                                    const val = config[field.name];
                                    const optionsPrepared = (field.options || []).map(opt => ({ label: opt, value: opt }));
                                    const valuePrepared = (Array.isArray(val) ? val : []).map(v => ({ label: v, value: v }));
                                    return (
                                        <React.Fragment key={index}>
                                        <FormGroup>
                                            <div className="d-flex align-items-center flex-wrap">
                                                <div className="custom-control custom-switch mr-2">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id={`switch-multi-${field.name}-${index}`}
                                                        checked={!!isOn}
                                                        onChange={(e)=>{
                                                            const on = e.target.checked;
                                                            setToggleOnState(prev => ({ ...prev, [field.name]: on }));
                                                            if (on) {
                                                                const initial = Array.isArray(field.defaultValue) ? field.defaultValue : (config[field.name] || []);
                                                                setConfig({ ...config, [field.name]: initial });
                                                            } else {
                                                                removeConfigKey(field.name);
                                                            }
                                                        }}
                                                    />
                                                    <label className="custom-control-label" htmlFor={`switch-multi-${field.name}-${index}`} />
                                                </div>
                                                <Label className="mb-0 mr-2">{field.name}</Label>
                                                {isOn && (
                                                    <div className="flex-grow-1 ml-1" style={{ minWidth: 180 }}>
                                                        <Select
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            options={optionsPrepared}
                                                            value={valuePrepared}
                                                            onChange={(value)=>{
                                                                setConfig({ ...config, [field.name]: (value || []).map(v => v.value) })
                                                            }}
                                                            isMulti
                                                            placeholder={`Select ${field.name}...`}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </FormGroup>
                                        </React.Fragment>
                                    )
                                }else if (field.type==='togglestring') {
                                    const isOn = toggleOnState[field.name] !== undefined ? toggleOnState[field.name] : (field.isOn === true);
                                    return (
                                        <React.Fragment key={index}>
                                        <FormGroup>
                                            <div className="d-flex align-items-center flex-wrap">
                                                <div className="custom-control custom-switch mr-2">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id={`switch-str-${field.name}-${index}`}
                                                        checked={!!isOn}
                                                        onChange={(e)=>{
                                                            const on = e.target.checked;
                                                            setToggleOnState(prev => ({ ...prev, [field.name]: on }));
                                                            if (on) {
                                                                const initial = field.defaultValue != null ? field.defaultValue : (config[field.name] || '');
                                                                setConfig({ ...config, [field.name]: initial });
                                                            } else {
                                                                removeConfigKey(field.name);
                                                            }
                                                        }}
                                                    />
                                                    <label className="custom-control-label" htmlFor={`switch-str-${field.name}-${index}`} />
                                                </div>
                                                <Label className="mb-0 mr-2">{field.name}<br/>{field.name === 'Lead age, maximum' && isOn && <span className="text-black-50">(in seconds, 3600=1 hour) {config[field.name] && <div>{humanizeDuration(config[field.name]*1000)}</div>}</span>}</Label>
                                                {isOn && (
                                                    <div className="flex-grow-1 ml-1" style={{ minWidth: 120 }}>
                                                        <AvInput
                                                            onChange={handleChange}
                                                            type="text"
                                                            name={field.name}
                                                            value={config[field.name] || ''}
                                                            placeholder={`Enter ${field.name}`}
                                                            required
                                                            className="w-100"
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </FormGroup>
                                        </React.Fragment>
                                    )
                                }
                            })
                        }
                        </>
                        )}
                    </AvForm>
                    </ModalBody>
                    <ModalFooter>
                        <Button type="submit" form={`scrubber-edit-form-${data.name}`} color="primary">Save</Button>
                        <Button color="secondary" onClick={() => setEdit(false)}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </div>
    )
}

export default Scrubber
